import { Button, Form, Icon, Input } from 'antd';
import React, { Component } from 'react';
import '../SearchForm/SearchForm.css';

class Search extends Component {
  componentDidMount() {
    if (typeof this.props.onRef === 'function') this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  clearTxtSearch = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { placeholder } = this.props;

    return (
      <Form className="search-frm" layout="inline" onSubmit={this.handleSubmit}>
        <Form.Item>
          {getFieldDecorator('searchTxt', {
            rules: [{ required: false, message: 'กรุณากรอกข้อความ' }],
          })(
            <Input
              prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={placeholder || 'ค้นหา'}
              style={{ width: '200px' }}
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}

const SearchForm = Form.create({ name: 'search-frm' })(Search);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/Payment/search-form.js